
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  // ---------------------------------------------------
  mixins: [CookiesCoreMixinVue],
  // ---------------------------------------------------
  props: {
    Prop: { type: Object as PropType<thing> }
  },
  data () {
    return {}
  },
  computed: {},
  // ---------------------------------------------------
  methods: {},
  // ---------------------------------------------------
  beforeCreate () {
    this.$router.push('/Catalogs/ViewCatalog/' + this.$route.params.CatalogID + '/' + this.$route.params.ItemID)
  },
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUnmount () {},
  // ---------------------------------------------------
  watch: {
    CurrentDialogs: function (newVal, oldVal) { // watch it
      if (newVal < oldVal) {
        // refresh Data
      }
    }
  }
})
